module.exports = __webpack_public_path__ + "static/media/logoMerxVetorizadaBranca.8c931ca5.png";